import { Box, Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';

const HomeTrendDownload = () => {
    const { selectedStation } = useStore().commonStore
    const { downloadChart } = useStore().homeTrendChartStore
    
    const handleDownload = () => {
        if (selectedStation) {
            downloadChart(selectedStation.name)
        }
    }
    
    return (
        <Box display="flex" justifyContent="flex-end">
            <Button onClick={handleDownload} variant="contained">Download</Button>
        </Box>
    )
}

export default observer(HomeTrendDownload)